import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
import { CardholderAvatarSizes, } from "./constants";
const { size } = ids || {};
const getBrandSize = (brandSize) => {
    switch (brandSize) {
        case CardholderAvatarSizes.small:
            return css `
        width: ${size.general.ids_size_general_24x};
        height: ${size.general.ids_size_general_24x};
      `;
        case CardholderAvatarSizes.medium:
            return css `
        width: ${size.general.ids_size_general_32x};
        height: ${size.general.ids_size_general_32x};
      `;
        case CardholderAvatarSizes.large:
            return css `
        width: ${size.general.ids_size_general_48x};
        height: ${size.general.ids_size_general_48x};
      `;
        default:
            return css `
        width: ${size.general.ids_size_general_24x};
        height: ${size.general.ids_size_general_24x};
      `;
    }
    return;
};
export const CardholderAvatarContainer = styled.div `
  box-sizing: border-box;
`;
export const StyledCardholderAvatar = styled.img `
  ${({ size }) => getBrandSize(size)}
`;
export const StyledPlaceHolder = styled.div `
  ${({ size }) => getBrandSize(size)}
  display: flex;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=CardholderAvatar.style.js.map